<template>
  <div class="mb-4">
    <label
      :for="textareaId"
      class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
    >
      {{ label }}
    </label>
    <textarea 
      :id="textareaId"
      v-model="notesValue"
      :rows="rows"
      class="px-1 mt-1 block w-full rounded-md border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
      :placeholder="placeholder" 
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  modelValue?: string;
  label?: string;
  placeholder?: string;
  rows?: number;
  textareaId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
  label: 'Notas',
  placeholder: 'Agrega notas...',
  rows: 3,
  textareaId: 'notes'
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const notesValue = computed({
  get: () => props.modelValue,
  set: (value: string) => emit('update:modelValue', value)
});
</script>
